module.exports = __webpack_public_path__ + "static/media/testimonial_empty@3x.2bb23a6a.png";